import React from "react";
import { gql } from "apollo-boost";
import { graphql } from "react-apollo";
import JobsList from "./JobsList";
import CenteredLoader from "./CenteredLoader";
import InfiniteScroller from "./InfiniteScroller";

const ITEMS_PER_PAGE = 15;

const SearchResults = ({ match, loading, jobs, hasMore, loadMoreEntries }) => {
  if (loading) return <CenteredLoader />;

  return (
    <InfiniteScroller hasMore={hasMore} loadMore={loadMoreEntries}>
      <JobsList match={match} jobs={jobs} />
    </InfiniteScroller>
  );
};

const JobSearchQuery = gql`
  query JobSearch(
    $offset: Int
    $franchiseId: ID
    $q: String!
    $skip: Boolean!
    $showArchived: Boolean
  ) {
    jobs(
      offset: $offset
      q: $q
      franchiseId: $franchiseId
      showArchived: $showArchived
    ) @skip(if: $skip) {
      ...JobsListJob
    }
  }
  ${JobsList.fragments.job}
`;

export default graphql(JobSearchQuery, {
  options: ({ franchiseId, q }) => ({
    variables: { q, franchiseId, skip: !q, offset: 0, showArchived: true },
    fetchPolicy: "network-only"
  }),
  props({ data: { loading, error, jobs, fetchMore } }) {
    return {
      loading,
      error,
      jobs,
      hasMore: jobs && jobs.length >= ITEMS_PER_PAGE,
      loadMoreEntries() {
        return fetchMore({
          variables: {
            offset: jobs.length
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
              return previousResult;
            }

            return {
              ...previousResult,
              jobs: [...previousResult.jobs, ...fetchMoreResult.jobs]
            };
          }
        });
      }
    };
  }
})(SearchResults);



// WEBPACK FOOTER //
// ./src/components/SearchResults.js